//custonm error class for handling the popup when errors occur


class PopupError extends Error {
    constructor(title, description, status = null) {
        super(description);
        this.title = title;
        this.description = description;
        this.status = status;
        this.name = "PopupError";
    }
}

export default PopupError;